import React, { Fragment, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';

import EditIcon from '@mui/icons-material/EditOutlined';
import MoreIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import pdfIcon from '../../assets/preop_icon.svg';
import videoIcon from '../../assets/block_icon.svg';
import imageIcon from '../../assets/image_icon.svg';

import Table from '../shared/table';

import './documents.scss';

const DocumentsTable = ({
  documents = [],
  onEditClick = () => {},
  onDeleteClick = () => {},
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  totalRows,
  order,
  setOrder,
  orderBy,
  setOrderBy,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const getIcon = (name) => {
    if (name && name.includes('.pdf')) {
      return pdfIcon;
    }
    if (name && name.includes('.mp4')) {
      return videoIcon;
    }
    return imageIcon;
  };

  const columns = useMemo(() => {
    return [
      {
        title: 'Name',
        field: 'name',
        type: 'custom',
        sort: true,
        formatter: (value) => (
          <div className='d-flex'>
            <img style={{ width: '20px' }} src={getIcon(value)} alt="file-icon" />
            <span style={{ fontWeight: 'bold', marginLeft: '8px' }}>{value}</span>
          </div>
        )
      },
      { title: 'Description', field: 'description', type: 'default', sort: true },
      {
        title: 'Countries',
        field: 'countries',
        type: 'custom',
        sort: true,
        formatter: (value) => (
          value?.map((country) => (
            <Chip
              key={country}
              size="small"
              label={country}
              variant="outlined"
              sx={{ fontWeight: 500, backgroundColor: 'var(--color-main-light)', borderColor: 'var(--color-main-border)', mr: 1 }}
            />
          ))
        ),
      },
      {
        title: '',
        field: 'id',
        type: 'custom',
        filter: false,
        width: 50,
        formatter: (value, row) => (
          <>
            <IconButton
              size="small"
              onClick={handleMenuOpen}
              aria-controls={`${row.id}_actions`}
              aria-haspopup="true"
              aria-label="actions"
              color="inherit"
              id={`${row.id}_actions`}
            >
              <MoreIcon color="secondary" />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              elevation={1}
              id={`${row.id}_actions`}
              keepMounted
              onClose={handleMenuClose}
              open={Boolean(anchorEl) && anchorEl.id === `${row.id}_actions`}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem
                onClick={() => {
                  onEditClick(row);
                  handleMenuClose();
                }}
              >
                <EditIcon fontSize="small" style={{ marginRight: 8 }} color="secondary" />
                Edit Document
              </MenuItem>
              <Divider />
              <MenuItem
                onClick={() => {
                  onDeleteClick(row?.id);
                  handleMenuClose();
                }}
              >
                <DeleteIcon fontSize="small" style={{ marginRight: 8, fill: '#F04438' }} />
                <Typography sx={{ color: '#F04438' }}>Delete Document</Typography>
              </MenuItem>
            </Menu>
          </>
        ),
      },
    ];
  }, [documents, anchorEl]);

  return (
    <Fragment>
      <Table
        stickyTable
        rows={documents}
        columns={columns}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalRows={totalRows}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
      />
    </Fragment>
  );
};

DocumentsTable.propTypes = {
  documents: PropTypes.array,
  distributors: PropTypes.array,
  onVerifyClick: PropTypes.func,
  onSMSClick: PropTypes.func
};

export default DocumentsTable;
